// extracted by mini-css-extract-plugin
export default {"container":"ynWpmwcQmU","list":"YcHVRcUqRT","assignment":"XtpZ4k4_q0","member":"mHbx3RnQXA","member_name":"cMCZ8N_3Gu","roles":"xz3mqopDq3","emptyText":"LYcWQwFWL8"};